(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino/game/assets/javascripts/model.js') >= 0) return;  svs.modules.push('/components/casino/game/assets/javascripts/model.js');

'use strict';

const useCloudCasinoApis = svs.core.detect.feature('ft-use-casino-cloud-apis');
class GameModel extends svs.components.casino.PubSub {
  constructor(game) {
    super();
    _.extend(this, game);
    this.changed = {};
    this.socketSubscriptions = 0;
    this.lastJackpotAmount = this.jackpotAmount || false;
    this.isSubscribingToLiveData = false;
    this.isSubscribingToJackpotData = false;
    this.gameStateOpen = 1;
    this.isReduced = window.matchMedia("(prefers-reduced-motion: reduce)") === true || window.matchMedia("(prefers-reduced-motion: reduce)").matches === true;
    this.log = svs.core.log.getLogger('component.casino.game.model');
    this.liveDataUnsubscribe = null;
    this.jackpotUnsubscribe = null;
    this.casinoMS = svs.core.svsSocket.get('/v1/casino-socket');
  }
  set(prop, value) {
    switch (prop) {
      default:
        this._set(prop, value);
        this._flush();
        break;
    }
  }
  _set(prop, value) {
    this.changed[prop] = true;
    this[prop] = value;
  }
  _flush() {
    this.emit('change', this.changed);
    this.changed = {};
  }
  hasSocketData() {
    return this.lobbyType === 'live' || this.jackpotId;
  }
  subscribeToSockets() {
    if (this.hasSocketData()) {
      this.socketSubscriptions++;
      this.lobbyType === 'live' && this.subscribeToLiveData();
      this.jackpotId && this.subscribeToJackpot();
    }
  }
  unSubscribeToSockets() {
    if (this.hasSocketData()) {
      this.socketSubscriptions--;
      if (this.socketSubscriptions === 0) {
        this.unSubscribeToLiveData();
        this.unSubscribeToJackpot();
      }
    }
  }
  onSocketUpdate(data) {
    if (!useCloudCasinoApis) {
      Object.prototype.hasOwnProperty.call(data, 'game') && this._diffLiveData(data.game);
      if (this.isReduced) {
        this.removeSocketListeners();
      }
    } else {
      const socketData = data.message;
      Object.prototype.hasOwnProperty.call(socketData, 'data') && this._diffLiveData(socketData);
      if (this.isReduced) {
        this.removeSocketListeners();
      }
    }
  }
  onJackpotUpdate(data) {
    if (!useCloudCasinoApis) {
      if (data.jackpot && data.jackpot.amount && this.jackpotAmount !== data.jackpot.amount) {
        this.lastJackpotAmount = this.jackpotAmount || false;
        this.set('jackpotAmount', data.jackpot.amount);
      }
      if (!this.jackpotAmount) {
        const elEmptyJackpot = document.querySelector("a[data-name=\"".concat(this.name, "\"] .casino-game-promo-badge-holder"));
        elEmptyJackpot.innerHTML = "<div class=\"casino-game-promo-badge\">".concat(this.badge || 'JACKPOTSPEL', "</div>");
      }
    } else {
      const jackpotData = data.message.data;
      if (jackpotData && jackpotData.amount && this.jackpotAmount !== jackpotData.amount) {
        this.lastJackpotAmount = this.jackpotAmount || false;
        this.set('jackpotAmount', jackpotData.amount);
      }
      if (!this.jackpotAmount) {
        const elEmptyJackpot = document.querySelector("a[data-name=\"".concat(this.name, "\"] .casino-game-promo-badge-holder"));
        elEmptyJackpot.innerHTML = "<div class=\"casino-game-promo-badge\">".concat(this.badge || 'JACKPOTSPEL', "</div>");
      }
    }
  }
  subscribeToLiveData() {
    if (!this.isSubscribingToLiveData) {
      this.liveDataUnsubscribe = this.subscribeToCasinoSocket(this.getLiveDataSocketUrl(), this.getLegacyLiveDataSocketUrl(), this.onSocketUpdate);
      this.isSubscribingToLiveData = true;
    }
  }
  unSubscribeToLiveData() {
    if (this.liveDataUnsubscribe) {
      this.liveDataUnsubscribe();
      this.liveDataUnsubscribe = null;
    }
    this.isSubscribingToLiveData = false;
  }
  getLiveDataSocketUrl() {
    return "/api/v1/casino/providers/".concat(this.provider.toLowerCase(), "/tables/").concat(this.liveTableId.toLowerCase());
  }
  getLegacyLiveDataSocketUrl() {
    return "/casino/1/gameinfo/livedata/".concat(this.liveTableId.toLowerCase(), "?supplier=").concat(this.provider);
  }
  getJackpotSocketUrl() {
    return "/api/v1/casino/providers/".concat(this.provider.toLowerCase(), "/jackpots/").concat(this.jackpotId.toLowerCase());
  }
  getLegacyJackpotSocketUrl() {
    return "/casino/1/gameinfo/jackpots/".concat(this.jackpotId.toLowerCase(), "?supplier=").concat(this.clientStartType);
  }
  subscribeToCasinoSocket(socketUrl, legacySocketUrl, onUpdate) {
    if (!useCloudCasinoApis) {
      svs.core.socket.subscribe(legacySocketUrl, onUpdate, this);
      return () => {
        svs.core.socket.unsubscribe(legacySocketUrl, onUpdate);
      };
    }
    const subscription = this.casinoMS.subscribe(socketUrl, data => onUpdate.call(this, data), {
      sendInitialUpdate: true
    });
    return () => {
      subscription.unsubscribe();
    };
  }
  subscribeToJackpot() {
    if (!this.isSubscribingToJackpotData) {
      this.jackpotUnsubscribe = this.subscribeToCasinoSocket(this.getJackpotSocketUrl(), this.getLegacyJackpotSocketUrl(), this.onJackpotUpdate);
      this.isSubscribingToJackpotData = true;
    }
  }
  fetchArticle() {
    const useLegacyJupiterApi = !svs.core.detect.feature('ft-use-cms-api-client-lb');
    if (useLegacyJupiterApi) {
      const options = {
        method: 'GET',
        path: "/content/2/id/".concat(this.articleId),
        data: {
          routesDomain: 'spela'
        }
      };
      svs.core.jupiter.call(options, data => {
        if (data.result) {
          this.set('article', data.result[0]);
        }
      });
      return;
    }

    const client = svs.content.shared.getCmsClient();
    client.v1.content.getById(this.articleId).then(item => {
      if (item) {
        this.set('article', item);
      }
    }).catch(e => {
      this.log.warn("Error fetching article for ".concat(this.title, " (CMS API)"), e);
    });
  }
  fetchDescription() {
    const useLegacyJupiterApi = !svs.core.detect.feature('ft-use-cms-api-client-lb');
    if (useLegacyJupiterApi) {
      const options = {
        method: 'GET',
        path: "/content/2/id/".concat(this.id),
        data: {
          routesDomain: 'spela',
          include: 'result.body'
        }
      };
      svs.core.jupiter.call(options, data => {
        if (data.result && data.result.length && data.result[0].body) {
          this.set('description', data.result[0].body);
        } else {
          this.log.warn("Error fetching description for ".concat(this.title), data.error);
        }
      });
      return;
    }

    const client = svs.content.shared.getCmsClient();
    client.v1.content.getById(this.id, {
      include: 'body'
    }).then(item => {
      if (item !== null && item !== void 0 && item.body) {
        this.set('description', item.body);
      } else {
        this.log.warn("Error fetching description for ".concat(this.title, " (CMS API)"), null);
      }
    }).catch(e => {
      this.log.warn("Error fetching description for ".concat(this.title, " (CMS API)"), e);
    });
  }
  unSubscribeToJackpot() {
    if (this.jackpotUnsubscribe) {
      this.jackpotUnsubscribe();
      this.jackpotUnsubscribe = null;
    }
    this.isSubscribingToJackpotData = false;
  }
  isFull() {
    return Boolean(this.lobbyType === 'live' && this.seatsTaken && this.seats && this.seats === this.seatsTaken.length);
  }
  _diffLiveData(data) {
    if (!useCloudCasinoApis) {
      data.provider = this.provider;
      data = svs.components.casino.game.interpretLiveData(data);
      for (const key in data) {
        if (Object.prototype.hasOwnProperty.call(data, key)) {
          if (!_.isEqual(data[key], this[key])) {
            this._set(key, data[key]);
          }
        }
      }
      if (Object.keys(this.changed).length) {
        this._flush();
      }
    } else {
      const socketData = data.data;
      socketData.provider = this.provider;
      const myData = svs.components.casino.game.interpretLiveData(socketData);
      for (const key in myData) {
        if (Object.prototype.hasOwnProperty.call(myData, key)) {
          if (!_.isEqual(myData[key], this[key])) {
            this._set(key, myData[key]);
          }
        }
      }
      if (Object.keys(this.changed).length) {
        this._flush();
      }
    }
  }
  removeSocketListeners() {
    this.lobbyType === 'live' && this.unSubscribeToLiveData();
    this.unSubscribeToJackpot();
  }
  destroy() {
    this.removeSocketListeners();
  }
}

setGlobal('svs.components.casino.game.GameModel', GameModel);

 })(window);